import { Injectable } from '@angular/core';
import { RedeemItem, RedeemItemLog } from '@mommy/models/vender.model';
import { VenderRedeemService } from '@mommy/services/vender/vender-redeem.service';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as _ from 'lodash';
import {
  DoRedeemItem,
  GetRedeemItemList,
  GetRedeemItemLog,
} from './vender-redeem.actions';

export interface VenderRedeemStateModel {
  RedeemItemList: RedeemItem[];
  RedeemItemLogList: RedeemItemLog[];
}

const defaultVenderRedeemState = (): VenderRedeemStateModel => {
  return {
    RedeemItemList: [],
    RedeemItemLogList: [],
  };
};

@State<VenderRedeemStateModel>({
  name: 'VenderRedeemState',
  defaults: defaultVenderRedeemState(),
})
@Injectable()
export class VenderRedeemState {
  constructor(private venderRedeemService: VenderRedeemService) {}

  @Selector()
  static _redeemItemList(state: VenderRedeemStateModel) {
    return state.RedeemItemList;
  }

  @Selector()
  static _redeemItemLogList(state: VenderRedeemStateModel) {
    return state.RedeemItemLogList;
  }

  @Selector([VenderRedeemState._redeemItemList])
  static redeemItemList(_redeemItemList: RedeemItem[]) {
    return _.chain(_redeemItemList)
      .map((item) => {
        const new_item = _.cloneDeep(item);
        new_item.backgroundImagePath =
          `url(${new_item.image_url})` + ', url(assets/img3/default_prod.png)';
        new_item.disabled = (item?.item_rest_qty || 0) <= 0;
        return new_item;
      })
      .orderBy(['point'], ['asc'])
      .value();
  }

  @Selector([VenderRedeemState._redeemItemLogList])
  static redeemItemLogList(_redeemItemLogList: RedeemItemLog[]) {
    return _.orderBy(_redeemItemLogList, ['redeem_txn_date'], ['desc']);
  }

  // ===============================================================================
  //                             Action
  // ===============================================================================

  // 取得兌換商品清單
  @Action(GetRedeemItemList)
  async GetRedeemItemList(ctx: StateContext<VenderRedeemStateModel>) {
    console.log('[Action] GetRedeemItemList');

    try {
      const result = await this.venderRedeemService.get_redeem_list();
      console.log('result', result);

      ctx.patchState({
        RedeemItemList: result?.data,
      });
    } catch (error) {
      console.error('GetRedeemItemList error', error);
      throw error;
    }
  }

  // 兌換商品
  @Action(DoRedeemItem)
  async DoRedeemItem(
    ctx: StateContext<VenderRedeemStateModel>,
    { payload }: DoRedeemItem
  ) {
    console.log('[Action] DoRedeemItem', payload);

    try {
      const result = await this.venderRedeemService.redeem_item(payload);
      console.log('result', result);
    } catch (error) {
      console.error('DoRedeemItem error', error);
      throw error;
    }
  }

  // 取得兌換商品紀錄
  @Action(GetRedeemItemLog)
  async GetRedeemItemLog(ctx: StateContext<VenderRedeemStateModel>) {
    console.log('[Action] GetRedeemItemLog');

    try {
      const result = await this.venderRedeemService.get_redeem_record();
      console.log('result', result);

      ctx.patchState({
        RedeemItemLogList: result?.data,
      });
    } catch (error) {
      console.error('GetRedeemItemLog error', error);
      throw error;
    }
  }
}
